module.exports = __webpack_public_path__ + "img/21.01cc90e5.svg";